<template>
    <div class="cz2__modal-popup cz2__modal-popup--done">
        <div class="cz2__modal-popup__body">
            <focus-lock>
                <div class="cz2__modal-popup__content" tabindex="0">
                    <button class="cz2__modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
                    </button>

                    <!-- Title -->
                    <div class="cz2__modal-popup__header cz2__type__header">
                        {{title}}
                    </div>

                    <!-- Description -->
                    <div class="cz2__modal-popup__body-copy">
                        <div v-html="description"></div>
                    </div>

                    <!-- Confirm switch -->
                    <button class="cz2__modal-popup__button-ok cz2__modal-popup__group-button" @click.prevent="confirm">
                        {{confirmMessage}}
                    </button>

                    <!-- Stay -->
                    <button class="cz2__modal-popup__button-cancel cz2__modal-popup__group-button" @click.prevent="close">
                        {{stayMessage}}
                    </button>

                    <!-- Save -->
                    <div class="cz2__leaving-save">
                        <button class="cz2__leaving-save__button" @click.prevent="confirmSave">
                            <span class="cz2__leaving-save__button-icon">
                            </span>

                            <span class="cz2__leaving-save__button-text cz2__type__small">
                                {{$t('POPUP_LEAVING_SAVE')}}
                            </span>
                        </button>
                    </div>

                </div>
            </focus-lock>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    #cz2.cz2 {
        .cz2__modal-popup__group-button {
            margin-top: 20px;
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },
        props: {
            switchTo: {
                type: String,
                default: 'group',
            },
        },
        computed: {
            title() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_ARE_YOU_SURE_GROUP')
                    : this.$t('GROUP_ARE_YOU_SURE_INDIVIDUAL');
            },
            description() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_TO_GROUP_DESCRIPTION')
                    : this.$t('GROUP_SWITCH_TO_INDIVIDUAL_DESCRIPTION');
            },
            confirmMessage() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_CONFIRM_GROUP')
                    : this.$t('GROUP_SWITCH_CONFIRM_INDIVIDUAL');
            },
            stayMessage() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_STAY_INDIVIDUAL')
                    : this.$t('GROUP_SWITCH_STAY_GROUP');
            },
            closeAction() {
                return this.switchTo === 'group'
                    ? 'showGroupConfirmation'
                    : 'showIndividualConfirmation';
            },
        },
        methods: {
            close() {
                this.$store.dispatch(this.closeAction, false);
            },

            confirm() {
                this.$store.dispatch(this.closeAction, false);
                this.$store.dispatch('setIsGroupOrder', this.switchTo === 'group');
            },

            confirmSave() {
                this.$store.dispatch('saveWishlist');
            },
        },
    };
</script>
